import React, { useContext, useEffect, useState } from "react";
// styled components
import { Row, Col, Table, Empty, Button, Input, Select, notification } from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// hooks
import { useGestionarPostulaciones } from "../../../../hooks/useGestionarPostulaciones";

// components
import { ModalVerPropuesta } from "./components/ModalVerPropuesta";
import { ModalGenerarInforme } from "./components/ModalGenerarInforme";
// icons
import {SearchOutlined } from "@ant-design/icons";
// data select
import {
  cantidadRegistros,
} from "../../../../utils/dataSelectOptions";

import "../../Convocatorias/old.scss";
import "./../GestionarPostulaciones/gestionarPostulaciones.scss";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ModalExportacion } from "../../../../components/Administrador/ModalExportacion/ModalExportacion";
import { ModalCodigos } from "../../../../components/Administrador/ModalCodigos/ModalCodigos";
import { ModalActualizar } from "../../../../components/Administrador/ModalCodigos/ModalActualizar";
import { ModalTipos } from "../../../../components/Administrador/ModalTipos/ModalTipos";
import { ModalEstado } from "../../../../components/Administrador/ModalEstado/ModalEstado";
import { ModalInformacion } from "../../../../components/Administrador/ModalInformacion/ModalInformacion";
import { useMaestras } from "../../../../hooks/useMaestras";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { TemplateContext } from "../../../../utils/template_context";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import { lineasVisibles } from "../../../../utils/lineasVisibles";
import {
  CHIPS_ESTADO,
  CLAVE_TODAS,
  colorDeFondo,
  contarChip,
  postulacionesDelChip,
} from "../../../../utils/chipsEstadoPostulacion";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { runWithConcurrency } from "../../../../utils/concurrencia";
import { contextoDeLaPostulacion, verificarPropuesta as verificarPropuestaCompleta } from "../../../../utils/verificarPropuesta";
import { EtapaVerificacion } from "../../../../utils/verificacionAdministrativa";
import { ModalEtapaVerificacion } from "../../../../components/Administrador/ModalEtapaVerificacion/ModalEtapaVerificacion";

import { itemRenderTable } from "../../../../utils/itemRenderTable";

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
  "Anulado": "#0051E6",
  "Evaluado": "#6435C9",
  "Por evaluar": "#F28C02",
};
const TiposIdentificacion: any = {
  "1": "Persona Natural",
  "3": "Grupo Conformado",
  "2": "Persona Juridica",
};

const TipoDocumento: any = {
  "1": "CC",
  "3": "CC",
  "2": "NIT",
}

/** Propuestas ya decididas: la verificación automática no las toca. */
const ESTADOS_CERRADOS = ["Aceptado", "Rechazado", "Beneficiario", "Evaluado", "Por evaluar", "Anulado"];

const fechaVerificacion = (): string => {
  const ahora = new Date();
  const dos = (n: number) => ('0' + n).slice(-2);
  return `${ahora.getFullYear()}-${dos(ahora.getMonth() + 1)}-${dos(ahora.getDate())} ${dos(ahora.getHours())}:${dos(ahora.getMinutes())}`;
};

export const GestionarPostulaciones = () => {
  let {
    allpostulaciones,
    setAllPostulaciones,
    modal,
    VerPropuesta,
    AceptarModalPropuesta,
    CancelarModal,
    postulacion,
    descargarArchivo,
    cantidadpáginas,
    cambiarCantidadPaginas,
    // categorias,
    lineasconvocatoria,
    obtenerCategoriasLineas,
    filtros,
    setFiltros,
    limpiarFiltros,
    buscarpostulaciones,
    loading
  } = useGestionarPostulaciones();
  const context = useContext(TemplateContext);

  const { obtenerLineaConvocatorias, lineaConvocatorias } = useMaestras();
  const [countSubsanable, setCountSubsanable] = useState<number>(0);
  const [idPostulacion, setIdPostulacion] = useState<number>();
  const [observaciones, setObservaciones] = useState<any>(null);
  const [user, setUser] = useState<any>({});

  // Chip de estado seleccionado encima de la tabla. Empieza en Total, que no
  // filtra nada.
  const [chipActivo, setChipActivo] = useState<string>(CLAVE_TODAS);
  const [paginaActual, setPaginaActual] = useState<number>(1);

  const alternarChip = (clave: string) => {
    // Volver a tocar el chip encendido quita el filtro.
    setChipActivo((actual) => (actual === clave ? CLAVE_TODAS : clave));
    setPaginaActual(1);
  };

  // Los numeros salen de la lista completa, no de lo que se esta mostrando,
  // para que al filtrar por un chip los demas sigan en su valor.
  const postulacionesMostradas = postulacionesDelChip(
    allpostulaciones,
    chipActivo
  );

  useEffect(() => {
    // Una busqueda nueva empieza en la primera pagina.
    setPaginaActual(1);
  }, [allpostulaciones]);

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    obtenerCategoriasLineas();
    obtenerLineaConvocatorias();
  }, []);

  useEffect(() => {
    // Este useEffect asegurará que el estilo de scroll se mantenga
    const scrollableDiv = document.querySelector('.my-scrollable-div') as HTMLElement;
    if (scrollableDiv) {
      scrollableDiv.style.overflowX = 'auto';
      scrollableDiv.style.whiteSpace = 'nowrap';
    }
  }, []);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "lg" ? "left" : false,
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Nombre de proyecto",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) =>
      <span style={{whiteSpace: "pre-line"}}>
        {data?.nombre_propuesta}
      </span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 150,
      render: (data: any) =>
      <span style={{ color: coloresEstado[data?.estado] }}>
        {data?.estado == 'Sin revisar' ? 'Inscrito sin revisar' : data?.estado}
      </span>,
    },
    {
      title: "Linea convocatoria",
      ellipsis: true,
      width: 300,
      render: (data: any) => {
        return <span style={{whiteSpace: "pre-line"}}>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
            <span style={{whiteSpace: "pre-line"}}>{datos.categoria_linea_convocatoria}</span>
        );
      },
    },
    {
      title: "Tipo Documento",
      width: 140,
      render: (datos: any) => {
        return (
            <span>{TipoDocumento[datos.tipo_participante]}</span>
        );
      },
    },
    {
      title: "Nro. Documento",
      width: 100,
      render: (datos: any) => {
        return (
            <span>{datos.numero_documento_participante}</span>
        );
      },
    },
    {
      title: "Creado por",
      width: 200,
      render: (datos: any) => {
        return (
            <span style={{whiteSpace: "pre-line"}}>{datos.nombre_representante}</span>
        );
      },
    },
    {
      title: "Fecha de creación",
      width: 100,
      render: (datos: any) => {
        return (
            <span>{datos.fecha_creacion}</span>
        );
      },
    },
    /*{
      title: "Actualizado por",
      width: 100,
      render: (datos: any) => {
        return (
            <span>{}</span>
        );
      },
    },
    {
      title: "Fecha Actualización",
      width: 100,
      render: (datos: any) => {
        return (
            <span>{datos.fecha_actualizacion}</span>
        );
      },
    },*/
    {
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Acciones
          </Col>
        </Row>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              <Button
                onClick={() => {
                  setIdPostulacion(datos.id_postulacion)
                  VerPropuesta(datos)
                }}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                Ver Más
              </Button>
            </Col>
          </Row>
      ),
    },
  ];
  const [verificandoLinea, setVerificandoLinea] = useState(false);
  const [openModalEtapaLinea, setOpenModalEtapaLinea] = useState(false);
  const [propuestasAVerificar, setPropuestasAVerificar] = useState<{ lista: any[]; omitidas: number }>({
    lista: [],
    omitidas: 0,
  });

  /** Verifica una propuesta y guarda las marcas. No cambia el estado: eso lo hace el profesional. */
  const verificarPropuesta = async (postulacionAVerificar: any, fecha: string, etapa: EtapaVerificacion) => {
    const resultado = await verificarPropuestaCompleta(
      postulacionAVerificar.documentos_administrativos,
      fecha,
      contextoDeLaPostulacion(postulacionAVerificar),
      { etapa, documentosTecnicos: postulacionAVerificar.documentos_tecnicos }
    );
    if (resultado.subsanados === 0 && resultado.aceptados === 0 && resultado.rechazados === 0) {
      return { cambiada: false };
    }

    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      postulacionAVerificar.id_postulacion,
      resultado.documentos
    );
    if (resultado.documentosTecnicos.length > 0) {
      await apiParticipantes.guardarDocumentosTecnicosPostulacion(
        postulacionAVerificar.id_postulacion,
        resultado.documentosTecnicos
      );
    }
    if (resultado.observacion) {
      await apiParticipantes.actualizarObservacion(postulacionAVerificar.id_postulacion, resultado.observacion);
    }
    return { cambiada: true, subsanados: resultado.subsanados };
  };

  const ejecutarVerificacionLinea = async (aVerificar: any[], etapa: EtapaVerificacion) => {
    setOpenModalEtapaLinea(false);
    setVerificandoLinea(true);
    const fecha = fechaVerificacion();
    let procesadas = 0;
    let conHallazgos = 0;
    const fallidas: string[] = [];

    try {
      notification.info({
        key: "verificando-linea",
        message: "Verificando documentos",
        description: `Revisando ${aVerificar.length} propuesta(s)...`,
        placement: "bottomRight",
        duration: 0,
      });

      await runWithConcurrency(
        aVerificar,
        async (p: any) => {
          try {
            const r = await verificarPropuesta(p, fecha, etapa);
            procesadas++;
            if (r.cambiada) conHallazgos++;
          } catch (error) {
            fallidas.push(p.radicado);
            console.error(`[Verificación] Error en ${p.radicado}:`, error);
          }
        },
        3
      );

      if (fallidas.length > 0) {
        notification.warning({
          message: `${fallidas.length} propuesta(s) con error`,
          description: `No se pudieron verificar: ${fallidas.slice(0, 15).join(", ")}${fallidas.length > 15 ? " y otras más (ver consola)" : ""}`,
          placement: "bottomRight",
          duration: 12,
        });
      }

      notification.success({
        key: "verificando-linea",
        message: "Verificación completada",
        description: `${procesadas} propuesta(s) revisadas, ${conHallazgos} con marcas propuestas` +
          (etapa === "segunda" ? " para rechazo por no subsanar" : "") +
          ". Revísalas y confirma antes de publicar el informe.",
        placement: "bottomRight",
        duration: 10,
      });

      await buscarpostulaciones();
    } catch (error) {
      console.error(error);
      notification.warning({
        key: "verificando-linea",
        message: "Error al verificar",
        description: "Ocurrió un error durante la verificación. Verifica tu sesión e intenta de nuevo.",
        placement: "bottomRight",
        duration: 8,
      });
    } finally {
      setVerificandoLinea(false);
    }
  };

  const verificarLinea = () => {
    const listado: any[] = allpostulaciones ?? [];
    const aVerificar = listado.filter((p: any) => !ESTADOS_CERRADOS.includes(p.estado));
    const omitidas = listado.length - aVerificar.length;

    if (aVerificar.length === 0) {
      notification.info({
        message: "No hay propuestas por verificar",
        description: listado.length === 0
          ? "El listado está vacío. Filtra por la línea que quieras revisar."
          : "Todas las propuestas del listado ya tienen una decisión final.",
        placement: "bottomRight",
      });
      return;
    }

    setPropuestasAVerificar({ lista: aVerificar, omitidas });
    setOpenModalEtapaLinea(true);
  };

  const routes = [{ nombre: "Postulaciones" }, { nombre: "Artistas" }];

  /* **** MODAL **** */
  const opcionesSelect = [
    { id: 1, nombre: "Aceptados", value: "Aceptado" },
    { id: 2, nombre: "No Aceptados", value: "Rechazado" },
    { id: 3, nombre: "Todos los postulados", value: "Todos" }
  ];

  const [openModal, setOpenModal] = useState(false);
  const [openModalCodigos, setOpenModalCodigos] = useState(false);
  const [openActualizarCodigos, setOpenActualizarCodigos] = useState(false);
  const [openModalTipo, setOpenModalTipo] = useState(false);
  const [openModalEstado, setOpenModalEstado] = useState(false);
  const [openModalInformacion, setOpenModalInformacion] = useState(false);
  const [openModalInforme, setOpenModalInforme] = useState(false);

  const openModalExportar = () => setOpenModal(true);
  const openModalGestionarCodigos = () => setOpenModalCodigos(true);
  const openModalModalActualizar = () => setOpenActualizarCodigos(true);
  const openModalGestionarTipoP = () => setOpenModalTipo(true);

  const [categorias, setCategorias] = useState([]);
  const handleLineaChange = async (id_linea: number | string) => {
    if (typeof id_linea === 'string') {
      // Convierte la cadena a número si es necesario
      id_linea = parseInt(id_linea, 10);
    }

    try {
      const { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      setCategorias(data);
      setFiltros({
        ...filtros,
        categoria: null,
        linea_estrategica: id_linea,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="background-color-F7FBFF h-100">
        <BreadCrumbAdmin routes={routes} />
        <div className="container-fluid ps-md-4 pe-md-4 main-c">
          <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
            Gestionar postulación de proyectos
          </div>

          <div className="sombra_card" style={{ marginBottom: "20px" }}>
            <div>
              <div className="header_card">
                <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                  Filtrar postulaciones
                </div>
              </div>
              <div className="body_card">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="row">
                      <div className="col-12 pb-2">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar por palabra
                        </span>
                      </div>
                      <div className="col-12 pb-2">
                        <Input
                          value={filtros.buscarpalabra}
                          suffix={
                            <SearchOutlined className="font-color-051923bf" />
                          }
                          onChange={(e) =>
                            setFiltros({
                              ...filtros,
                              buscarpalabra: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                    <div className="row mb-3">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar línea
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          showSearch
                          value={filtros.linea_estrategica}
                          optionFilterProp="children"
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any) => handleLineaChange(value)}
                        >
                          {lineasVisibles(lineaConvocatorias, user.documento).map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>{nombre}</Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar categoría
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any, option: any) =>
                            setFiltros({ ...filtros, categoria: option.children })
                          }
                        >
                          {categorias.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  {/*
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar estado
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any) =>
                            setFiltros({ ...filtros, estado: value })
                          }
                        >
                          {EstadosPostulacion.map(({ value, text }) => (
                            <Select.Option key={value} value={value}>
                              {text}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar Año
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          options={years}
                          onChange={(value: any) =>
                            setFiltros({ ...filtros, anio: value })
                          }
                        >
                        </Select>
                      </div>
                    </div>
                  </div>
                  */}
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-azul-ghost m-0"
                onClick={limpiarFiltros}
              >
                Limpiar Filtros
              </Button>
              <Button
                className="button-azul-radius m-0"
                onClick={buscarpostulaciones}
              >
                Buscar
              </Button>
            </div>
          </div>

          <div className="row-shadow">
            <div 
              className="col-12 col-md-12 mb-3" 
              style={{ 
                overflowX: 'auto', 
                overflowY: 'hidden',
                width: '100%',
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'thin'
              }}
            >
              <div 
                className="d-flex align-items-center" 
                style={{ 
                  minWidth: 'max-content',
                  fontSize: 'small',
                  padding: '8px 0'
                }}
              >
                {CHIPS_ESTADO.map((chip) => {
                  const activo = chipActivo === chip.clave;
                  return (
                    <button
                      key={chip.clave}
                      type="button"
                      aria-pressed={activo}
                      title={
                        chip.estados === null
                          ? "Mostrar todas las postulaciones"
                          : `Mostrar solo: ${chip.etiqueta}`
                      }
                      onClick={() => alternarChip(chip.clave)}
                      className={`d-flex align-items-center mx-2 ${chip.clase}`}
                      style={{
                        flexShrink: 0,
                        font: "inherit",
                        color: "inherit",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        borderRadius: 16,
                        padding: "2px 10px",
                        // Todos llevan el borde de su color; el encendido se
                        // distingue por el fondo y la letra mas gruesa.
                        border: `1px solid ${chip.color}`,
                        background: activo
                          ? colorDeFondo(chip.color)
                          : "transparent",
                        fontWeight: activo ? 600 : "normal",
                      }}
                    >
                      {chip.etiqueta} :{" "}
                      <span className={chip.claseNumero}>
                        &nbsp;{contarChip(allpostulaciones, chip.clave)}
                      </span>
                    </button>
                  );
                })}
                <div
                  className="d-flex align-items-center registos-adminconvocatoria mx-2"
                  style={{ width: 200, flexShrink: 0 }}
                >
                  <span className="font-family-Montserrat-Regular font-size-9px font-color-7E7E7E pe-2 d-flex align-items-center">
                    Registros por página
                  </span>
                  <Dropdown
                    className="d-flex align-items-center select-registros-adminconvocatoria no-margin"
                    defaultValue={cantidadpáginas}
                    options={cantidadRegistros}
                    icon={
                      <Icon
                        className="font-color-051923bf iconos-dropdown-global"
                        name="angle down"
                      />
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  className="height-30"
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadpáginas,
                    current: paginaActual,
                    onChange: (pagina: number) => setPaginaActual(pagina),
                  }}
                  dataSource={postulacionesMostradas}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>

        <ModalVerPropuesta
          modal={modal}
          AceptarModal={AceptarModalPropuesta}
          postulacion={postulacion}
          descargarArchivo={descargarArchivo}
          setAllPostulaciones={setAllPostulaciones}
          allpostulaciones={allpostulaciones}
          CancelarModal={CancelarModal}
          lineasConvocatoria={lineasconvocatoria}
          setCountSubsanable={setCountSubsanable}
          countSubsanable={countSubsanable}
          setIdPostulacion={setIdPostulacion}
          idPostulacion={idPostulacion}
          setObservaciones={setObservaciones}
          observaciones={observaciones}
        />
        <Row className="container-sticky-footer botonera-sticky-scroll">
          {/* <Col span={12}>
          <Button className="button-blanco-radius">ATRÁS</Button>
        </Col> */}
          {
            user.role_id == 1 ?
            <div className="d-flex align-items-center">
              <Button className="button-azul-radius" onClick={openModalGestionarTipoP} style={{ marginRight: '5px' }} >
                Gestionar tipo de participantes
              </Button>
              <Button className="button-azul-radius" onClick={openModalGestionarCodigos} style={{ marginRight: '5px' }} >
                Gestionar códigos
              </Button>
              <Button className="button-azul-radius" onClick={openModalModalActualizar} style={{ marginRight: '5px' }} >
                Gestionar códigos nuevos
              </Button>
              <Button className="button-azul-radius" onClick={openModalExportar}>
                Exportar datos
              </Button>
            </div>: <span></span>
          }
          <Button
            className="button-azul-radius"
            onClick={verificarLinea}
            loading={verificandoLinea}
            disabled={verificandoLinea}
            style={{ marginLeft: '5px' }}
          >
            Verificar con IA
          </Button>
          <Button
            className="button-azul-radius"
            onClick={() => setOpenModalInforme(true)}
            style={{ marginLeft: '5px' }}
          >
            Generar informe
          </Button>
        </Row>
      </div>
      <ModalEtapaVerificacion
        visible={openModalEtapaLinea}
        onCancel={() => setOpenModalEtapaLinea(false)}
        onConfirmar={(etapa) => ejecutarVerificacionLinea(propuestasAVerificar.lista, etapa)}
        cargando={verificandoLinea}
        detalle={
          <div>
            <p>
              Se revisarán <b>{propuestasAVerificar.lista.length}</b> propuesta(s) del listado actual.
              {propuestasAVerificar.omitidas > 0 && (
                <> Se omitirán {propuestasAVerificar.omitidas} que ya tienen decisión final.</>
              )}
            </p>
            <p>No se modifica ningún documento que ya haya decidido una persona.</p>
          </div>
        }
      />

      {openModal && (
        <ModalExportacion
          openModal={openModal}
          setOpenModal={setOpenModal}
          opcionesSelect={opcionesSelect}
          modulo="Participante"
          consulta="1"
        />
      )}
      {openModalCodigos && (
        <ModalCodigos
          openModal={openModalCodigos}
          setOpenModal={setOpenModalCodigos}
        />
      )}
      {openActualizarCodigos && (
        <ModalActualizar
          openModal={openActualizarCodigos}
          setOpenModal={setOpenActualizarCodigos}
        />
      )}
      {openModalTipo && (
        <ModalTipos
          openModal={openModalTipo}
          setOpenModal={setOpenModalTipo}
        />
      )}
      {openModalEstado && (
        <ModalEstado
          openModal={openModalEstado}
          setOpenModal={setOpenModalEstado}
        />
      )}
      {openModalInformacion && (
        <ModalInformacion
          openModal={openModalInformacion}
          setOpenModal={setOpenModalInformacion}
        />
      )}
      {openModalInforme && (
        <ModalGenerarInforme
          openModal={openModalInforme}
          setOpenModal={setOpenModalInforme}
          lineasConvocatoria={lineaConvocatorias}
        />
      )}
    </>
  );
};
